// cSpell:ignore languagedetector
import i18next, { i18n, Resource } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

export const i18nextCreator = (resources?: Resource, debug = false): i18n => {
  i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: 'en',
      debug,
      interpolation: {
        escapeValue: false, // React already does escaping
      },
      ...(debug && {
        parseMissingKeyHandler: (key: string) => {
          // Extract the last part of the key (e.g., "jum" from "questionnaire.answers.jum")
          // This returns the original user input instead of an error message
          const parts = key.split('.');
          return parts[parts.length - 1];
        },
      }),
      resources: resources,
    })
    .catch((error) => {
      console.error('i18next initialization failed:', error);
    });

  return i18next;
};
